import styled from 'styled-components';
    
export const Content = styled.div`
   overflowY: scroll;
`;
  
export const Button = styled.div`
   position: fixed; 
   width: 100%;
   bottom: 100px;
   height: 20px;
   font-size: 3rem;
   z-index: 1;
   cursor: pointer;
   color: teal;
`